import { gql } from '@apollo/client';

export const TILE_IMAGE_FRAGMENT = gql(/* GraphQL */ `
  fragment tileImageFragment on ContentPage {
    content {
      ... on Show {
        tileImage {
          ...detailImageFragment
        }
      }
      ... on Movie {
        tileImage {
          ...detailImageFragment
        }
      }
      ... on Collection {
        tileImage {
          ...detailImageFragment
          hasTitleTreatment
        }
      }
      ... on PayPerViewEvent {
        tileImage {
          ...detailImageFragment
        }
      }
    }
  }
`);
export const IMAGE_DETAILS_FRAGMENT = gql(/* GraphQL */ `
  fragment detailImageFragment on Image {
    uri
    overlayImages {
      uri
      position
    }
  }
`);
export const LINEAR_CHANNEL_TILE_FRAGMENT = gql(/* GraphQL */ `
  fragment linearChannelTile on LinearChannel {
    id
    title
    tileImage(aspectRatio: 1.77) {
      uri
    }
    slot {
      start
      end
      hasParentalRestriction
      hasMultipleAudioTracks
      live
      rating {
        classification
        advisories
      }
      programme {
        __typename
        ... on Title {
          id
          title
        }
        ... on Movie {
          heroImage {
            uri
          }
          primaryGenres {
            title
          }
          year
        }
        ... on Episode {
          id
          title
          number
          season {
            id
            number
          }
          show {
            __typename
            id
            title
            type
            primaryGenres {
              title
            }
            heroImage {
              uri
            }
          }
        }
      }
    }
    ...viewingMethodWithoutOffer
  }
`);

export const VIEWING_METHODS_WITHOUT_OFFER = gql(/* GraphQL */ `
  fragment viewingMethodWithoutOffer on ViewableContent {
    viewingMethods {
      __typename
      ... on VodViewingMethod {
        packages {
          id
          title
          mySubscription {
            __typename
          }
        }
      }
      ... on LinearViewingMethod {
        packages {
          id
          title
          mySubscription {
            __typename
          }
        }
      }
      ... on PayPerViewViewingMethod {
        payPerViewOffer {
          id
          price {
            amount
          }
          purchases {
            id
            purchasedAt
            state
          }
        }
      }
      ... on TvodViewingMethod {
        __typename
        tvodOffer {
          id
          price {
            amount
          }
          startingPeriod
          rentalPeriod
          expressRelease
          purchases {
            id
            purchasedAt
            state
            tvodWatchState {
              startedWatchingAt
            }
          }
        }
      }
    }
  }
`);

export const CONTENT_PAGE_COMMON_FRAGMENT = gql(/* GraphQL */ `
  fragment contentPageCommonFragment on ContentPage {
    ...contentPageFragment
    ...tileImageFragment
  }
`);
export const CONTENT_PAGE_FRAGMENT = gql(/* GraphQL */ `
  fragment contentPageFragment on ContentPage {
    pageInfo {
      endCursor
      hasNextPage
    }
    content {
      __typename
      ... on Title {
        id
        title
      }
      ... on Show {
        id
        title
        type
        heroImage {
          uri
        }
        primaryGenres {
          title
        }
        year
        numberOfSeasons
      }
      ... on Movie {
        id
        title
        heroImage {
          uri
        }
        primaryGenres {
          title
        }
        year
        duration
        rating {
          classification
          advisories
        }
      }
      ... on PayPerViewEvent {
        heroImage {
          uri
        }
      }
      ... on Episode {
        __typename
        id
        title
        show {
          id
          type
          heroImage {
            uri
          }
        }
        season {
          number
        }
        liveEvent {
          startTime
          endTime
        }
        number
        duration
        image(type: SHOW_OVERLAY) {
          uri
          overlayImages {
            uri
            position
          }
        }
        rating {
          classification
          advisories
        }
        asset {
          id
          hasParentalRestriction
          instantReplay
        }
        promotedSlot {
          id
          start
          end
          channel {
            id
            title
          }
        }
        ...viewingMethodWithoutOffer
        viewingMethods {
          ... on VodViewingMethod {
            dateRange {
              start
            }
          }
          ... on TvodViewingMethod {
            dateRange {
              start
            }
          }
        }
      }
      ...linearChannelTile
      ... on Collection {
        id
        title
        heroImage {
          uri
        }
      }
      ... on CollectionLink {
        collection {
          id
          title
          heroImage {
            uri
          }
        }
        tileImage {
          uri
        }
        namedFilters {
          id
          title
        }
      }
    }
  }
`);
